import { ComponentType, FunctionComponent, ReactElement } from 'react'

import MuiTooltip, { tooltipClasses } from '@mui/material/Tooltip'
import Zoom from '@mui/material/Zoom'
import { TransitionProps } from '@mui/material/transitions'

const AccordionHeaderToolTip: FunctionComponent<AccordionHeaderToolTipProps> = ({
  children, title, enterDelay = 800, arrow = true,
  placement = 'bottom', TransitionComponent = Zoom, bgColor = '#84619C', textColor = 'white', ...props
}) => (
  <MuiTooltip
    {...{ title, enterDelay, arrow, placement, TransitionComponent }}
    componentsProps={{
      tooltip: {
        sx: {
          backgroundColor: bgColor,
          color: textColor,
          fontSize: '0.875rem',
          [`& .${tooltipClasses.arrow}`]: { color: bgColor, fontSize: '0.5rem' }
        }
      }
    }}
    {...props}
  >
    {children}
  </MuiTooltip>
)

interface AccordionHeaderToolTipProps {
  children: ReactElement
  title: string
  leaveDelay?: number
  enterDelay?: number
  arrow?: boolean
  placement?: 'bottom' | 'left' | 'right' | 'top' | 'bottom-end' | 'bottom-start' | 'left-end' | 'left-start' | 'right-end' | 'right-start' | 'top-end' | 'top-start'
  open?: boolean
  TransitionComponent?: ComponentType<TransitionProps>
  bgColor?: string
  textColor?: string
}

export default AccordionHeaderToolTip
